import Cookies from 'js-cookie';
import { devMode, dlog } from './lib/devLibrary';
import { createConsentToggleButton, fadeConsent, handleFunctionalScript, handleMarketingScript } from './lib/handlingLibrary';

let $ = jQuery.noConflict();

export function init() {
	const assetsObject = {
		maps: {
			url: 'https://maps.googleapis.com/maps/api/js?key=' + mxms_vars.mxms_maps,
			id: 'google-maps-cdn',
			value: mxms_vars.mxms_maps
		},
		gtag: {
			url: 'https://www.googletagmanager.com/gtag/js?id=' + mxms_vars.mxms_gtag,
			id: 'google-analytics-cdn',
			value: mxms_vars.mxms_gtag
		},
		pixel: mxms_vars.mxms_fb,
		expire: mxms_vars.mxms_expire,
		devMode: mxms_vars.mxms_dev_mode
	};
	let needToReload = true;
	let currentSetCookies = Cookies.get();
	let availableCookieTypes = getAvailableCookieTypes();
	let showCookieNotice = true;
	const cConsent = $('#mxms-cookie-consent');

	let fCookie, mCookie, dMode, flagFunctional, flagMarketing;

	dMode = assetsObject.devMode;
	devMode(dMode, assetsObject, currentSetCookies);

	fCookie = currentSetCookies['functional'];
	mCookie = currentSetCookies['marketing'];

	if (currentSetCookies['essential']) {
		showCookieNotice = false;
		needToReload = false;
		$('.btn-hide-cookie-consent').show();
	}

	dlog(dMode, needToReload, 'FIRST VISIT: ');

	if (showCookieNotice) {
		$('body').addClass('show-cookie-notice'); //! Gehört noch geändert zur richtigen Klasse!
		fadeConsent(cConsent);
	}

	if (fCookie === 'true') {
		console.log('fcookie true');
		$('.entry-checkbox.functional').prop('checked', true);
	} else {
		$('.mxms-map').each(function () {
			$(this).parent().addClass('no-consent');
			createConsentToggleButton($('.no-consent'));
		});
		console.log('fcookie false');
	}

	if (mCookie === 'true') {
		$('.entry-checkbox.marketing').prop('checked', true);
	}

	handleFunctionalScript(assetsObject.maps, fCookie, dMode);
	handleMarketingScript(assetsObject.gtag, mCookie, dMode);

	/**
	 * Button handles
	 */

	// accept all cookies
	$('#mxms-cookie-accept-all').on('click', function (e) {
		e.preventDefault();
		setCookies(availableCookieTypes);
		dlog(dMode, Cookies.get(), 'NEW COOKIES');
		//fadeConsent(cConsent);
		location.reload();
	});

	// remove all cookies
	$('.btn-remove-all-cookies').on('click', function (e) {
		e.preventDefault();
		deleteCookies(availableCookieTypes);

		dlog(dMode, 'CLEAR ALL CLICKED');
		location.reload();
	});

	$('.btn-show-cookie-consent').on('click', function (e) {
		e.preventDefault();
		$('.btn-hide-cookie-consent').show();
		fadeConsent(cConsent);

		if (fCookie === 'true') {
			console.log('fcookie true');
			$('.entry-checkbox.functional').prop('checked', true);
			flagFunctional = true;
		}

		if (mCookie === 'true') {
			$('.entry-checkbox.marketing').prop('checked', true);
			flagMarketing = true;
		}

		dlog(dMode, needToReload, 'NEED RELOAD: ');
	});

	$('.btn-hide-cookie-consent').on('click', function (e) {
		e.preventDefault();
		needToReload = false;
		cConsent.fadeOut();
		dlog(dMode, needToReload, 'NEED RELOAD: ');
	});

	// accept selected cookies
	$('#mxms-cookie-accept-selection').on('click', function (e) {
		e.preventDefault();
		let selection = [];

		$('.entry-checkbox').each(function () {
			if ($(this).is(':checked')) {
				dlog(dMode, $(this).data('type'), 'SELECTED CHECKBOXES');
				selection.push($(this).data('type'));
			}
		});

		// delete cookies which are not in selection
		let arrdelete = toDelete(availableCookieTypes, selection);
		deleteCookies(arrdelete);

		// set cookies which are selected
		setCookies(selection);

		location.reload();

		// // get the current available cookies
		// let currentSetCookies = Cookies.get();
		// // console.log('AFTER CLICK', currentSetCookies);

		// // build Values for scripts
		// let fCookie = currentSetCookies['functional'];
		// let mCookie = currentSetCookies['marketing'];

		// // execute scripts
		// handleFunctionalScript(assetsObject.maps, fCookie);
		// handleMarketingScript(assetsObject.gtag, mCookie);

		// if ((needToReload && fCookie !== 'true') || mCookie !== 'true') {
		// 	console.log('RELOAD!!!!!!!');
		// 	// location.reload();
		// }
		// // hide consent
		// fadeConsent(cConsent);
	});
}

export const toDelete = (first, second) => {
	const spreaded = [...first, ...second];
	return spreaded.filter((el) => {
		return !(first.includes(el) && second.includes(el));
	});
};

export function getAvailableCookieTypes() {
	let choices = [];

	$('.entry-checkbox').each(function () {
		let type = $(this).data('type');
		choices.push(type);
	});

	return choices;
}

export function setCookies(cookieArray, expire = 7) {
	cookieArray.forEach((cookieType) => {
		Cookies.set(cookieType, true, { expires: expire });
		// console.log(cookieType + ' set!'); //! Developement
	});
}

export function deleteCookies(cookieArray) {
	cookieArray.forEach((cookieType) => {
		Cookies.remove(cookieType);
	});
}
